export const DEFAULT_MANAGER_DATA_LIST = [
  {
    businessManagerSeq: 0,
    businessSeq: 0,
    businessName: '',
    managerName: '',
    contactNo: '',
    mobilePhone: '',
    department: null,
    position: '',
    representationYn: '',
    useYn: '',
    managerMemberWhetherStatus: null,
    managerMemberWhetherStatusName: null,
    invitationYn: null,
    invitationDate: null,
    invitationPeriodExpiredYn: null,
    invitationCompletionYn: '',
    guideComment: null,
    regDt: '',
    regMemberSeq: 0,
    modDt: '',
    modMemberSeq: 0,
    invitationResultMsg: null,
    invitationJoinResultFailYn: '',
  },
];
